import { Navigate, RouteObject } from 'react-router-dom';

import MessagesInboxIcon from '../../../assets/images/icons/messages-inbox-icon.svg';
import MessagesPersonIcon from '../../../assets/images/icons/messages-person-icon.svg';

import MessagesInbox from '../components/MessageInbox';

export const DEFAULT_MESSAGE_ROUTE = 'inbox';

const MessagesInboxRoutes: Array<RouteObject> = [{ path: ':threadId', element: <MessagesInbox /> }];

export const MessagesRoutes: Array<RouteObject> = [
  { index: true, element: <Navigate to={DEFAULT_MESSAGE_ROUTE} replace /> },
  { path: 'inbox', element: <MessagesInbox />, children: MessagesInboxRoutes },
];

export const messagesRoutesIcons = [
  { path: 'inbox', iconURL: MessagesInboxIcon },
  { path: '*', iconURL: MessagesPersonIcon },
];
